import PropTypes from "prop-types";
import React from "react";
import deepEqual from "deep-equal";
import { FacetValue, FilterValue } from "./types";
import { appendClassName, getFilterValueDisplay } from "./view-helpers";

function MultiCheckboxFacet(_ref) {
  var className = _ref.className,
      label = _ref.label,
      onMoreClick = _ref.onMoreClick,
      onRemove = _ref.onRemove,
      onSelect = _ref.onSelect,
      options = _ref.options,
      showMore = _ref.showMore,
      values = _ref.values,
      showSearch = _ref.showSearch,
      onSearch = _ref.onSearch,
      searchPlaceholder = _ref.searchPlaceholder;
  return React.createElement("fieldset", {
    className: appendClassName("sui-facet", className)
  }, React.createElement("legend", {
    className: "sui-facet__title"
  }, label), showSearch && React.createElement("div", {
    className: "sui-facet-search"
  }, React.createElement("input", {
    className: "sui-facet-search__text-input",
    type: "search",
    placeholder: searchPlaceholder || "Search",
    onChange: function onChange(e) {
      onSearch(e.target.value);
    }
  })), React.createElement("div", {
    className: "sui-multi-checkbox-facet"
  }, options.length < 1 && React.createElement("div", null, "No matching options"), options.map(function (option) {
    var checked = !!values.find(function (value) {
      if (value && value.name && option.value.name === value.name) return true;
      if (deepEqual(option.value, value)) return true;
      return false;
    });
    return React.createElement("label", {
      key: "".concat(getFilterValueDisplay(option.value)),
      htmlFor: "example_facet_".concat(label).concat(getFilterValueDisplay(option.value)),
      className: "sui-multi-checkbox-facet__option-label"
    }, React.createElement("div", {
      className: "sui-multi-checkbox-facet__option-input-wrapper"
    }, React.createElement("input", {
      id: "example_facet_".concat(label).concat(getFilterValueDisplay(option.value)),
      type: "checkbox",
      className: "sui-multi-checkbox-facet__checkbox",
      checked: checked,
      onChange: function onChange() {
        return checked ? onRemove(option.value) : onSelect(option.value);
      }
    }), React.createElement("span", {
      className: "sui-multi-checkbox-facet__input-text"
    }, getFilterValueDisplay(option.value))), React.createElement("span", {
      className: "sui-multi-checkbox-facet__option-count"
    }, option.count.toLocaleString("en")));
  })), showMore && React.createElement("button", {
    type: "button",
    className: "sui-facet-view-more",
    onClick: onMoreClick,
    "aria-label": "Show more options"
  }, "+ More"));
}

MultiCheckboxFacet.propTypes = {
  label: PropTypes.string.isRequired,
  onMoreClick: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(FacetValue).isRequired,
  showMore: PropTypes.bool.isRequired,
  values: PropTypes.arrayOf(FilterValue).isRequired,
  className: PropTypes.string,
  showSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string
};
export default MultiCheckboxFacet;